<template>
  <el-table :data="data" size="mini" stripe border height="100%">
    <el-table-column min-width="160" label="广告名称" align="center" prop="materialName"></el-table-column>
    <el-table-column min-width="120" label="单次曝光（s）" align="center" prop="materialDuration"></el-table-column>
    <el-table-column min-width="520" label="URL" align="center">
      <template slot-scope="{row}">
        <p class="url_p">
          <span class="url_span">{{ row.materialUrl }}</span>
          <span class="url_copy" @click="copyUrl(row)" :class="{copied: row.copied}">
            <i class="iconfont icon-copy"></i>
          </span>
        </p>
      </template>
    </el-table-column>
    <el-table-column width="140" label="操作" align="center">
      <template slot-scope="{row}">
        <el-button type="text" style="color:#FF3973;" @click="preview(row)">预览</el-button>
        <el-button type="text" style="color:#282729;" @click="deleteRow(row)">删除</el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  name: 'ListTable',
  props: {
    data: Array,
    default () {
      return []
    }
  },
  data () {
    return {}
  },
  methods: {
    deleteRow (row) { // 投放详情click
      this.$emit('deleteRow', row)
    },
    preview (row) {
      window.open(row.materialUrl)
    },
    copyUrl (row) {
      const input = document.createElement('input');
      input.setAttribute('style', 'height:0')
      document.body.appendChild(input);
      input.setAttribute('value', row.materialUrl);
      input.select();
      if (document.execCommand('copy')) {
        document.execCommand('copy');
        this.$message.success('复制成功')
      }
      document.body.removeChild(input);
      this.$forceUpdate()
    }
  }
}
</script>
<style lang="sass">
.ol-buton
  color: #282729
  font-size: 12px
  font-weight: 500
  line-height: 1.2
  margin-bottom: 10px
  cursor: pointer
  &:last-child
    margin-bottom: 0
  &.red
    color: #ff3973

.url_p
  text-align: left
  .url_span
    display: inline-block
  .url_copy
    float: right
    display: none
    cursor: pointer
    font-size: 16px
    &.copied
      color: #FF3973
  &:hover
    .url_copy
      display: inline-block

::v-deep .el-table
  border-top: none
  height: 100%
  .el-table__header
    background: #F1F1F1
    .cell
      border-right: 1px solid #D4D4D4
      color: #282729
      height: 24px
      line-height: 24px
    .is-leaf
      border-right: none
      background: #F1F1F1
  .el-table__row
    td
      padding: 10px 0
</style>
